import './auth.scss';
import {Outlet} from "react-router-dom";
import React, {Component} from 'react';

class Auth extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={'auth'}>
                <Outlet/>
            </div>

        );
    }
}

export default Auth;